"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixAlignedPhantom = void 0;
function fixAlignedPhantom(tex) {
    return tex.replace(/&\s*\\phantom\s*(=|\{\s*=\s*})/g, "&\\phantom{{}={}}");
}
exports.fixAlignedPhantom = fixAlignedPhantom;
